import { Lead } from '../../../services/dtos/lead';
import {
  FbLeadEvent, PurchaseEvent, TrackingEvent, sendEvent, sendFbLeadEvent, sendFbPurchaseEvent, sendMicrosoftEvent, sentPinterestLeadTracking,
} from '../../services/tracking/tracking';
import {
  EVALUATION_LEAD_AS,
  EVALUATION_LEAD_URL,
  EVALUATION_THANK_YOU_AS,
  EVALUATION_THANK_YOU_URL,
  THANK_YOU_AS,
  THANK_YOU_URL,
  URLObject,
  goToPage,
} from '../links';

const LOCALITY_VALUE: { [key: string]: number } = {
  milano: 57.80,
  torino: 40.26,
  genova: 19.21,
  bologna: 29.56,
  monza: 72.54,
  modena: 83.36,
  roma: 25.00,
  pisa: 19.09,
  pavia: 14.00,
  como: 21.01,
  asti: 15.00,
  bari: 15.00,
  bergamo: 15.00,
  brescia: 15.00,
  catania: 15.00,
  ferrara: 15.00,
  lecco: 15.00,
  lodi: 15.00,
  napoli: 25.00,
  padova: 15.00,
  taranto: 15.00,
  treviso: 15.00,
  varese: 15.00,
  verona: 15.00,
  venezia: 15.00,
};

function leadToPurchaseEvent(lead: Lead):PurchaseEvent {
  return {
    id: lead.locality ?? 'no-locality',
    value: LOCALITY_VALUE[lead.locality?.toLowerCase()] ?? 1,
  };
}

function fbLeadEvent(category: string, name: string, lead: Lead):FbLeadEvent {
  return {
    category,
    name,
    value: LOCALITY_VALUE[lead.locality?.toLowerCase()] ?? 1,
  };
}

export function sendEventAndRedirect<T extends TrackingEvent>(event: string, params: T, urlObject: URLObject) {
  sendEvent(event, params);
  goToPage(urlObject);
}

export function sendLeadSubmitEventAndRedirect(label: string, lead: Lead) {
  const event = 'lead_submit';
  const params = {
    category: 'lead',
    action: 'submit',
    label,
    leadId: lead.id,
    value: Math.round(LOCALITY_VALUE[lead.locality?.toLowerCase()] ?? 1),
    dimensions: {
      dimension6: lead.id,
    },
  };
  sendFbPurchaseEvent(leadToPurchaseEvent(lead));
  sendFbLeadEvent(fbLeadEvent(params.category, params.label, lead));
  sendMicrosoftEvent(event, params);
  sentPinterestLeadTracking(label);
  return sendEventAndRedirect(event, params, {
    url: THANK_YOU_URL,
    as: THANK_YOU_AS,
  });
}

export function sendEvaluationFormSubmitEventAndRedirect(label: string) {
  return sendEventAndRedirect('form_submit', {
    category: 'form',
    action: 'submit',
    label,
  }, {
    url: EVALUATION_LEAD_URL,
    as: EVALUATION_LEAD_AS,
  });
}

export function sendEvaluationLeadSubmitEventAndRedirect(label: string, lead: Lead) {
  const event = 'lead_submit';
  const params = {
    category: 'lead',
    action: 'submit',
    label,
    leadId: lead.id,
    value: Math.round(LOCALITY_VALUE[lead.locality?.toLowerCase()] ?? 1),
    dimensions: {
      dimension6: lead.id,
    },
  };
  sendFbPurchaseEvent(leadToPurchaseEvent(lead));
  sendFbLeadEvent(fbLeadEvent(params.category, params.label, lead));
  sendMicrosoftEvent(event, params);
  sentPinterestLeadTracking(label);
  return sendEventAndRedirect(event, params, {
    url: EVALUATION_THANK_YOU_URL,
    as: EVALUATION_THANK_YOU_AS,
  });
}
